import { Skeleton, Stack, Typography } from '@mui/material'
import type { FC } from 'react'
import type { To } from 'react-router'

import { COLORS, unit } from '@hcr/ui'

import { LayoutNavigationBack } from '../../../../common'
import { AdditionalInfoListLoading } from '../additional-info-list'
import { TicketDivider } from '../ticket-divider'

import {
  LayoutTicketDetailsInactiveContainer,
  LayoutTicketDetailsInactiveContent,
  LayoutTicketDetailsInactiveHeader,
  LayoutTicketDetailsInactiveName,
  LayoutTicketDetailsInactiveFooter,
} from './LayoutTicketDetailsInactiveComponents'

interface LayoutTicketDetailsInactiveLoadingProps {
  backNavigationPath: To
}

export const LayoutTicketDetailsInactiveLoading: FC<LayoutTicketDetailsInactiveLoadingProps> = ({
  backNavigationPath,
}) => {
  return (
    <LayoutNavigationBack to={backNavigationPath} arrowVariant='text'>
      <LayoutTicketDetailsInactiveContainer>
        <LayoutTicketDetailsInactiveContent>
          <LayoutTicketDetailsInactiveHeader>
            <LayoutTicketDetailsInactiveName>
              <Stack gap={unit(1)}>
                <Typography variant='labelM' color={COLORS.grey[700]}>
                  <Skeleton width={unit(40)} height={unit(6)} />
                </Typography>
                <Typography component='h1' variant='headlineM'>
                  <Skeleton width={unit(40)} height={unit(6)} />
                </Typography>
              </Stack>
              <Skeleton width={unit(20)} height={unit(6)} />
            </LayoutTicketDetailsInactiveName>
            <Skeleton width='100%' height={unit(10)} variant='rectangular' />
          </LayoutTicketDetailsInactiveHeader>
          <TicketDivider />
          <Skeleton width='100%' height={unit(60)} />
        </LayoutTicketDetailsInactiveContent>
        <LayoutTicketDetailsInactiveFooter>
          <AdditionalInfoListLoading />
          <Skeleton width='100%' height={unit(12)} variant='rectangular' />
        </LayoutTicketDetailsInactiveFooter>
      </LayoutTicketDetailsInactiveContainer>
    </LayoutNavigationBack>
  )
}
